import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Cross from '../icons/Cross';
const StyledCloseButton = styled.button `
    background-color: transparent;
    outline: none;
    border: none;
    cursor: pointer;
`;
const StyledCross = styled(Cross) `
    width: 14px;
    height: 14px;
    fill: ${props => props.theme.primary.base};
`;
const CloseButton = ({ onClick, ...props }) => (_jsx(StyledCloseButton, { onClick: onClick, ...props, children: _jsx(StyledCross, {}) }));
export default CloseButton;
